import React from 'react';
import { motion } from 'framer-motion';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}
export function Card({
  children,
  className = '',
  hover = false,
  onMouseEnter,
  onMouseLeave
}: CardProps) {
  return <motion.div onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} className={`relative overflow-hidden rounded-2xl bg-[rgba(255,255,255,0.55)] border border-cardline p-8 ${className}`} whileHover={hover ? {
    y: -4,
    boxShadow: '0 12px 28px -12px rgba(27,42,58,0.18)'
  } : {}} initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.5
  }} data-id="element-212" data-mp="d3q4lfbxt2aw">
      {children}
    </motion.div>;
}